import React from 'react';
import QuizOptions from './QuizOptions';

import {
  quizStatusBarIconStyle,
  quizStatusBarWrapper,
  quizTitleStyle,
  quizWrapperStyle
} from './QuizScreenStyles';
import { useAppStore } from '../../hooks/useAppStore';

interface QuizWrapperProps {
  activeQuestionIndex: number;
}

const ActiveQuestionIcon = () => {
  return (
    <svg
      css={quizStatusBarIconStyle}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx={6} cy={6} r="5.5" stroke="white" />
      <circle cx={6} cy={6} r={3} fill="white" />
    </svg>
  );
};
const InActiveQuestionIcon = () => {
  return (
    <svg
      css={quizStatusBarIconStyle}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx={6} cy={6} r="5.5" stroke="white" />
    </svg>
  );
};

const QuizWrapper: React.FC<QuizWrapperProps> = ({ activeQuestionIndex }) => {
  const { gamificationState = {} } = useAppStore();
  const { questions = [] } = gamificationState;

  const renderQuestionStatusBar = () => {
    return questions?.map((item, index) => {
      if (index <= activeQuestionIndex) {
        return <ActiveQuestionIcon key={item?.id} />;
      }
      return <InActiveQuestionIcon key={item?.id} />;
    });
  };

  return (
    <div css={quizWrapperStyle}>
      {questions?.length > 1 && (
        <div css={quizStatusBarWrapper}>{renderQuestionStatusBar()}</div>
      )}
      <h3 css={quizTitleStyle}>
        {questions?.[activeQuestionIndex]?.questionText}
      </h3>
      {activeQuestionIndex >= 0 && questions && (
        <QuizOptions question={questions[activeQuestionIndex]} />
      )}
    </div>
  );
};

export default QuizWrapper;
